export const EMPTY_POINT = {
    label: '',
    latitude: '',
    longitude: '',
    radius: 10
}

/**
 *
 * @param {String[]} fields list of the fields for which we want to create a computed property
 * @returns {Object} Object to insert in the computed property of a component to link it to the ui/georadar store
 */
export const generateLinkBetweenFormAndStore = fields =>
    fields.reduce((computed, field) => {
        computed[field] = {
            get() {
                return this.$store.state.ui.georadar.form.point[field]
            },
            set(value) {
                this.setFormField({ field, value })
            }
        }
        return computed
    }, {})
